import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Translate } from "react-localize-redux";
import { renderSelectField } from "../../../utils/formUtils";
import { chooseRecoveryMethodAction } from "../../../redux/actions/accountRecovery.actions";

const AccountRecoveryMethodForm = ({
  chooseRecoveryMethodAction,
  handleSubmit
}) => (
  <div className="col-lg-4 text-center">
    <h3 id="sign-in-brand">
      <Translate id="accountRecoveryMethod" />
    </h3>
    <p>
      Choose how you want to recover your account. A code will be sent to you to
      confirm your identity.
    </p>
    <br />
    <div className="row align-items-center justify-content-center">
      <div className="col-lg-6 text-center">
        <form
          onSubmit={handleSubmit(values => chooseRecoveryMethodAction(values))}
        >
          <Field
            label="Recovery method"
            hideLabel={false}
            name="recoveryMethod"
            type="select"
            id="recovery-method-input"
            component={renderSelectField}
            selectOptions={[
              { value: "email", text: "Email" },
              { value: "text", text: "Text" }
            ]}
            selectOptionText={"text"}
            selectOptionValue={"value"}
          />
          <br />
          <button type="submit" id="login-btn" className="btn btn-primary">
            Enter
          </button>
        </form>
      </div>
    </div>
  </div>
);

export default reduxForm({
  form: "AccountRecoveryMethodForm"
})(
  connect(
    null,
    { chooseRecoveryMethodAction }
  )(AccountRecoveryMethodForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/AccountRecoveryMethodForm/AccountRecoveryMethodForm.jsx